export default {
    sales: [],
    loading: false
};



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/sales_budget_by_contacts_warehouses/state.js